import { network } from 'services/network';

export const getDataStory = (params) => {
    const url = `api/bo/project/getDataStory?id=${params}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
